var _defs, _ellipse, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsPrimeTimeDinners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 41.27,
    cy: 56.1,
    rx: 9.3,
    ry: 7.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.36,48.66c0,8.22-7.49,14.88-16.74,14.88-26.03,0-27.89,18.6-48.35,18.6-15.41,0-27.89-11.66-27.89-26.03,0-7.01,3.92-13.92,9.3-18.14,20.42-16.02,58.17-15.15,78.78,.62,3.19,2.44,4.9,6.07,4.9,10.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.92,48.66c0,4.1-4.17,7.44-9.3,7.44-8.13,0-14.36,1.61-19.42,3.87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.36,48.66v14.88c0,8.22-7.49,14.88-16.74,14.88-26.03,0-27.89,18.6-48.35,18.6-15.41,0-27.89-11.66-27.89-26.03v-14.88"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsPrimeTimeDinners);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_PrimeTimeDinners.bc2573dfdc961bcf7ef3ea678644ebae.svg";
export { ForwardRef as ReactComponent };